import { t } from "ttag";

import { UpsellRemoteSync } from "metabase/admin/upsells";
import { useHasTokenFeature, useSetting } from "metabase/common/hooks";
import { getPlan, isProPlan } from "metabase/common/utils/plan";
import { usePageTitle } from "metabase/hooks/use-page-title";
import { PLUGIN_REMOTE_SYNC } from "metabase/plugins";

export function RemoteSyncSettingsPage() {
  usePageTitle(t`Remote sync`, { titleIndex: 1 });

  const hasRemoteSync = useHasTokenFeature("remote_sync");
  const tokenFeatures = useSetting("token-features");
  const isPro = isProPlan(getPlan(tokenFeatures));

  if (hasRemoteSync || isPro) {
    return <PLUGIN_REMOTE_SYNC.RemoteSyncSettings />;
  }

  return <UpsellRemoteSync source="settings-git-sync" />;
}
